import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_V_L, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { Component_TagEditor } from '../../shared-components/index.js';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { dbObjectToId, MUSTNeverHappenException } from '@nu-art/ts-common';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import './Component_MacroTagEditor.scss';
import { ModuleFE_Tag } from '../../../_entity.js';
const ViewMode_Edit = 'edit';
const ViewMode_View = 'view';
export class Component_MacroTagEditor extends TS_EditableItemComponentProto {
    // ######################### Lifecycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        state.uiTagGroups = this.translateIntoUITagGroups(state.editable.item.tagGroups);
        return state;
    }
    // ######################### Logic #########################
    getViewMode = () => this.state.editMode ? ViewMode_Edit : ViewMode_View;
    updateMacroTagGroups = async () => {
        const tagGroups = this.translateFromUITagGroups(this.state.uiTagGroups);
        await this.state.editable.updateObj({ tagGroups });
    };
    translateFromUITagGroups(uiTagGroups) {
        return uiTagGroups.map(uiTagGroup => {
            return {
                key: uiTagGroup.key._id,
                value: uiTagGroup.value.map(dbObjectToId),
            };
        });
    }
    translateIntoUITagGroups(tagGroups) {
        return tagGroups.map(tagGroup => {
            const key = ModuleFE_Tag.cache.unique(tagGroup.key);
            if (!key)
                throw new MUSTNeverHappenException(`Could not find tag for id ${tagGroup.key}`);
            const value = tagGroup.value.map(id => {
                const tag = ModuleFE_Tag.cache.unique(id);
                if (!tag)
                    throw new MUSTNeverHappenException(`Could not find tag for id ${id}`);
                return tag;
            });
            return {
                key,
                value
            };
        });
    }
    // ######################### Render #########################
    renderLabelInput = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', error: editable.hasError('label'), children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: ViewMode_View, renderer: () => _jsx("div", { className: '', children: editable.item.label }) },
                    { key: ViewMode_Edit, renderer: () => _jsx(DefaultEditor_InputText, { editable: editable, prop: 'label' }) }
                ] }) });
    };
    renderGroups = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Tag Groups', children: _jsx(Component_TagEditor, { tags: this.state.uiTagGroups, groupTagFilter: () => true, singleTagFilter: (tag, groupTag) => tag.tagIds[0] === groupTag._id, disableEdit: !this.state.editMode, onChange: this.updateMacroTagGroups }) });
    };
    render() {
        return _jsxs(LL_V_L, { className: 'macro-tag-editor', children: [this.renderLabelInput(), this.renderGroups()] });
    }
}
//# sourceMappingURL=Component_MacroTagEditor.js.map